import type { WordProgress } from "./types";
const MIN = 60_000, DAY = 86_400_000;
export const INTERVALS = [10 * MIN, DAY, 4 * DAY, 12 * DAY, 30 * DAY];
export const LEECH_THRESHOLD = 4;

export function applyAnswer(p: WordProgress, correct: boolean, now: number): WordProgress {
  const stage = correct ? Math.min(p.stage + 1, 4) : 0;
  const lapses = correct ? p.lapses : p.lapses + 1;
  const mastered = p.mastered || (correct && p.stage === 4);
  return { ...p, stage, lapses, seen: p.seen + 1,
    leech: lapses >= LEECH_THRESHOLD, mastered,
    nextDue: new Date(now + INTERVALS[stage]).toISOString(),
    learnedAt: p.learnedAt ?? new Date(now).toISOString(),
    updatedAt: new Date(now).toISOString() };
}
export const isMastered = (p: WordProgress) => p.mastered;
export const quizType = (p: WordProgress): "mc" | "matching" => (p.seen < 2 ? "mc" : "matching");

/** 複習優先度評分,分數越高越值得先複習(逾期 > 易忘 > 新詞 > 即將到期 > 已掌握) */
export function reviewPriority(p: WordProgress | undefined, nowMs: number): number {
  if (!p) return 100; // 新詞:保留適量新詞流入
  if (p.mastered) return -1000; // 已掌握:優先級最低
  const due = new Date(p.nextDue).getTime();
  let s = 0;
  if (due <= nowMs) s += 1000 + Math.min((nowMs - due) / DAY, 30) * 10; // 逾期,越久越優先
  if (p.leech) s += 600 + p.lapses * 20; // 易忘詞加強
  s += p.lapses * 5;
  s -= Math.min(Math.max((due - nowMs) / DAY, 0), 60); // 到期日越近越優先
  return s;
}
